import { render } from "./ClientCallDetail.vue?vue&type=template&id=541bbbb4"
import script from "./ClientCallDetail.vue?vue&type=script&lang=js"
export * from "./ClientCallDetail.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__